import styled from "styled-components";

export const ViewusersSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 50px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  h2 {
    display: flex;
    justify-content: center;
  }
  .delete-button {
    align-self: flex-end;
    padding: 1rem;
    gap: 1rem;
    display: flex;
  }
`;
